export default __webpack_public_path__ + "static/plume-modeling-d737f8dee0f5dc0ab4f5f65c24064179.mp4";